import React from "react";
import PropTypes from "prop-types";

import {
    ColorSelectionContainer,
    ColorInputContainer,
    SelectedColor,
    PaletteButtonContainer,
    PickerIconButton,
    StyledHexColorInput
} from "./styles";

const ColorSelectionControls = ({
    activeColor,
    setActiveColor,
    addToRecentColorsPalette,
    title,
    pickerIcon,
    onClick
}) => {
    return (
        <ColorSelectionContainer>
            <SelectedColor data-testid="selected-color" color={activeColor} />

            {/* COLOR PICKER TEXT INPUT */}
            <ColorInputContainer>
                <StyledHexColorInput
                    color={activeColor}
                    onChange={color => {
                        setActiveColor({ color });
                    }}
                    onBlur={addToRecentColorsPalette}
                    onKeyPress={e => {
                        if (e.key === "Enter") {
                            addToRecentColorsPalette();
                        }
                    }}
                    aria-label="selected color"
                />
            </ColorInputContainer>

            {/* OPEN COLOR WHEEL BUTTON */}
            <PaletteButtonContainer>
                <PickerIconButton
                    aria-label={title}
                    type="button"
                    onClick={onClick}
                >
                    {pickerIcon}
                </PickerIconButton>
            </PaletteButtonContainer>
        </ColorSelectionContainer>
    );
};

ColorSelectionControls.propTypes = {
    activeColor: PropTypes.string.isRequired,
    setActiveColor: PropTypes.func.isRequired,
    addToRecentColorsPalette: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    pickerIcon: PropTypes.element.isRequired,
    onClick: PropTypes.func.isRequired
};

export default ColorSelectionControls;
